import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import lang from './modules/lang';
import layout from './modules/layout';
import loading from './modules/loading';
import setting from './modules/setting';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    lang,
    layout,
    loading,
    setting,
  },
  strict: debug,
});
